import React from 'react'
import { CLIENT_LIST_LIMIT } from 'utils/client-list-constant'
//STYLES
import { TableCountProps } from './Table.props'
import { TableCountContainer, TableCountText } from './Table.styled'

const TableCount = ({ totalCount }: TableCountProps) => {
  return (
    <TableCountContainer>
      <TableCountText>
        Showing{' '}
        {totalCount < CLIENT_LIST_LIMIT ? totalCount : CLIENT_LIST_LIMIT} of{' '}
        {totalCount} data
      </TableCountText>
    </TableCountContainer>
  )
}

export default TableCount
